export const DEFAULT_LANGUAGE_ENGLISH = {value: "en", label: "English", isRtl: false};
export const LANGUAGE_OPTIONS = [
    {value: "en", label: "English", isRtl: false},
    {value: "hi", label: "हिंदी", isRtl: false},
    {value: "mr", label: "मराठी", isRtl: false},
    // {value: "kn", label: "ಕನ್ನಡ", isRtl: false}, //Hidden options for blue dart use case for now.
    // {value: "ta", label: "தமிழ்", isRtl: false},
    // {value: "te", label: "తెలుగు", isRtl: false},
    // {value: "bn", label: "বাংলা", isRtl: false}
];